import apiClient from './client';
import type { QuestionCountParams, QuestionCountResponse } from '../types/questions';

// Re-export types so existing imports still work
export type { QuestionCountParams, QuestionCountResponse };

export async function fetchQuestionCount(
  params?: QuestionCountParams,
  certification?: string,
): Promise<QuestionCountResponse> {
  const { data } = await apiClient.get<QuestionCountResponse>(
    '/api/questions/count',
    { params: { ...params, ...(certification ? { certification } : {}) } },
  );
  return data;
}
